@if (refusal(); as shown) {
  <div
    #callout
    role="alert"
    data-sign-in-as-refusal
    class="fixed flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 p-4 text-base text-amber-900 shadow-lg dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
    [style.top.px]="position().top"
    [style.left.px]="position().left"
    [style.width.px]="width">
    <i class="pi pi-lock mt-1 text-base" aria-hidden="true"></i>
    <span class="flex-1 leading-normal">{{ shown.message }}</span>
    <p-button icon="pi pi-times" [text]="true" [rounded]="true" size="small" severity="secondary" ariaLabel="Close" (onClick)="dismiss()" />
  </div>
}
